import React, { Component, MouseEvent, ReactNode } from 'react';
import { BackgroundJob, BackgroundJobStatus } from '../../../../domain/job/JobDomain';
import { query } from '@trlogic/client-js';
import CollectionNames from '../../../../constant/CollectionNames';
import JobListItem from './JobListItem';
import { OverlayPanel } from 'primereact/overlaypanel';
import { CustomFilterItemProps } from '../../CustomFilterItem';
import { generateUUIDV4 } from '../../../../util/Generator';
import FilterParser from '../../../../helpers/FilterParser';
import Icon from '../../../../icons/Icon';
import CustomPaginator, { CustomPaginatorProps } from '../../CustomPaginator';
import JobService from '../../../../service/JobService';
import ServiceContainer from '../../../../config/ServiceContainer';
import { ServiceNames } from '../../../../constant/ServiceNames';
import EmptyComponent from '../../empty-components/EmptyComponent';
import CustomDismissible from '../../CustomDismissible';
import ComponentName from '../../../../constant/ComponentName';
import { createPortal } from 'react-dom';
import and = query.and;
import eq = query.eq;
import empty = query.empty;
import _ from 'lodash';
import LanguageUtil from '../../../../util/LanguageUtil';

class JobContainer extends Component<{}, State> {
  public state = new State();

  private jobService: JobService = ServiceContainer.getInstance().get(ServiceNames.JOB);
  private overlayRef: OverlayPanel | null = null;

  private jobInterval: NodeJS.Timer | undefined;

  public render(): ReactNode {
    const { jobs, status, currentPage, rows, totalRecord } = this.state;
    return (
      <CustomDismissible id={'job-container'} onDismiss={() => this.setState({ isOpen: false })}>
        <div id={'job-container'} className={'flex items-center cursor-pointer justify-center relative bg-transparent bg-[#FFFFFF29] rounded-full h-8 w-8'}>
          <span onClick={this.toggleOpen} className={'flex items-center cursor-pointer justify-center rounded-full h-8 w-8'}>
            <Icon icon={'download'} size={16} color={'white'} />
          </span>
          {this.state.isOpen && (
            <div>
              {createPortal(
                <div className={`top-0 left-0 h-full w-full bg-[#111111] z-[1001] opacity-30 ${this.state.isOpen ? 'fixed' : 'hidden'}`}></div>,
                document.body,
              )}
              <div
                style={{ boxShadow: '0px 4px 6px -2px #00000008,0px 12px 16px -4px #00000014' }}
                className={
                  'flex flex-col h-[500px] overflow-y-scroll gap-y-5 absolute top-7 right-0 bg-white px-5 py-5 rounded-xl border-[1px] border-[#E0E4E8] !z-[1002]'
                }
              >
                <div className={'flex items-center justify-center bg-main-gray gap-x-2  rounded-[8px] px-1 py-1'}>
                  <div
                    onClick={() => this.onChangeStatus('PENDING')}
                    className={` ${status == 'PENDING' ? 'bg-white job-header-shadow' : 'bg-transparent'} flex items-center cursor-pointer gap-x-1 text-f-black-2 text-[14px] px-2 py-1 rounded-[8px]`}
                  >
                    <Icon icon={'undeploy'} size={14} />
                    <p>{LanguageUtil.get({ id: 'common.status.pending', defaultMessage: 'Pending' })}</p>
                  </div>
                  <div
                    onClick={() => this.onChangeStatus('PROCESSING')}
                    className={` ${status == 'PROCESSING' ? 'bg-white job-header-shadow' : 'bg-transparent'} flex items-center cursor-pointer gap-x-1 text-f-black-2 text-[14px] px-2 py-1 rounded-[8px]`}
                  >
                    <Icon icon={'autoplay'} size={14} />
                    <p>{LanguageUtil.get({ id: 'common.status.processing', defaultMessage: 'Processing' })}</p>
                  </div>
                  <div
                    onClick={() => this.onChangeStatus('FAILED')}
                    className={` ${status == 'FAILED' ? 'bg-white job-header-shadow' : 'bg-transparent'} flex items-center cursor-pointer gap-x-1 text-f-black-2 text-[14px] px-2 py-1 rounded-[8px]`}
                  >
                    <Icon icon={'error'} size={14} />
                    <p>{LanguageUtil.get({ id: 'common.status.failed', defaultMessage: 'Failed' })}</p>
                  </div>
                  <div
                    onClick={() => this.onChangeStatus('FINISHED')}
                    className={` ${status == 'FINISHED' ? 'bg-white job-header-shadow' : 'bg-transparent'} flex items-center cursor-pointer gap-x-1 text-f-black-2 text-[14px] px-2 py-1 rounded-[8px]`}
                  >
                    <Icon icon={'check'} size={14} />
                    <p>{LanguageUtil.get({ id: 'common.status.finished', defaultMessage: 'Finished' })}</p>
                  </div>
                  <div onClick={(e) => this.openFilter(e)} className={'flex items-center justify-center'}>
                    <Icon icon={'date'} size={16} className={'text-gray-500 hover:text-primary hover:cursor-pointer'} />
                  </div>
                </div>
                {jobs != undefined && jobs.length > 0 ? (
                  jobs.map((job: BackgroundJob, index: number) => {
                    return (
                      <JobListItem
                        key={index}
                        job={job}
                        download={() => {
                          this.jobService.download(job.id!, job);
                        }}
                        remove={() => {
                          this.jobService.delete(job.id!);
                        }}
                      />
                    );
                  })
                ) : (
                  <div className={'text-center text-gray-500 h-full'}>
                    <EmptyComponent type={ComponentName.JOBS} createDisabled />
                  </div>
                )}
                <div className={'flex w-full items-center justify-center'}>
                  <CustomPaginator
                    fixed={true}
                    currentPage={currentPage}
                    currentRecords={jobs.length}
                    rows={rows}
                    totalRecords={totalRecord}
                    rowsPerPageOptions={[]}
                    onPageChange={this.onPageChange}
                  />
                </div>
              </div>
            </div>
          )}
        </div>
      </CustomDismissible>
    );
  }

  public componentWillUnmount() {
    clearInterval(this.jobInterval);
  }

  private fetchData = async () => {
    this.setState({ loading: true });
    const { filters, rows, currentPage, status } = this.state;
    const jobQuery: query.SelectQueryBuilder = FilterParser.toQuery(
      _.cloneDeep(filters),
      query.QueryBuilder.select()
        .limit(rows)
        .skip((currentPage - 1) * rows)
        .orderBy({ field: 'timestamp', operator: 'DESC' })
        .from(CollectionNames.JOBS),
    );
    const statusFilter = eq('status', status);
    const jobFilter = and(statusFilter, jobQuery.build().filter || empty());
    jobQuery.where(jobFilter);
    const count = await this.jobService.getCount(query.QueryBuilder.select().from(CollectionNames.JOBS).where(statusFilter).build());
    const jobs = await this.jobService.findMany(jobQuery.build());
    this.setState({ totalRecord: count, jobs, loading: false });
  };

  private onChangeStatus = (status: BackgroundJobStatus) => {
    this.setState({ status: status }, () => {
      this.fetchData();
    });
  };

  private openFilter = (e: MouseEvent) => {
    e.preventDefault();
    this.overlayRef?.toggle(e);
  };

  private onPageChange = (event: CustomPaginatorProps) => {
    this.setState({ rows: event.rows, currentPage: event.page }, this.fetchData);
  };

  private toggleOpen = async () => {
    if (this.state.isOpen) {
      clearInterval(this.jobInterval);
      this.jobInterval = undefined;
    } else {
      this.jobInterval = setInterval(async () => {
        await this.fetchData();
      }, 10 * 1000);
      await this.fetchData();
    }
    this.setState({ isOpen: !this.state.isOpen });
  };
}

class State {
  jobs: BackgroundJob[] = [];
  loading: boolean = false;
  status: BackgroundJobStatus = 'FINISHED';
  filters: Array<CustomFilterItemProps> = [
    {
      id: generateUUIDV4(),
      field: undefined,
      operator: '',
      value: '',
      logic: 'and',
    },
  ];
  isOpen: boolean = false;

  rows = 5;
  totalRecord = 10;
  currentPage = 1;
}

export default JobContainer;
